import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { Account, Journal, Payment, Transaction } from 'src/app/shared/models/finance';
import { CommonService } from 'src/app/shared/services/common.service';
import { FinanceService } from 'src/app/shared/services/finance.service';




@Component({
  selector: 'app-cashbook-crud',
  templateUrl: './cashbook-crud.component.html',
  styleUrls: ['./cashbook-crud.component.scss']
})
export class CashbookCrudComponent implements OnInit {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() journal: Journal;
  @Input() context: Context;
  @Input() journals: Journal[] = [];
  @Input() journalId: number;
  public payment: Payment;
  public journalForm: FormGroup;
  public transationForm: FormGroup;
  public paymentForm: FormGroup;
  public payForm: FormGroup;
  public accounts: Account[] = [];
  public transactions: Transaction[] = [];
  public payments: Payment[];
  public refId: number;
  public submitted: boolean = false;
  public submittedPayment: boolean = false;
  private modified: boolean = false;
  public hasTransationId: boolean = false;
  public isPaymentEnabled: boolean = false;
  public payId: number;
  public paymentId: number;
  public hasPaymentIds: any;
  public hasPaymentId: boolean = false;
  public hasToPaymentId: boolean = false
  private warningShown = false;
  private warningPaymentShown = false;

  constructor(
    private commonService: CommonService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private finaceService: FinanceService,
    private toaster: ToastrService,
  ) { }
  ngOnInit(): void {
    this.setJournalForm(this.journal);
    this.setPaymentForm(this.payment);
    this.setTransations([]);
    this.setPayments([]);
    if (this.f.id.value) {
      this.getTransactions(this.journal?.id);
      this.getPayments(this.journal?.id);
      this.getjournalId(this.journal?.id)

    }
    this.finaceService.getAccounts(this.context.companyId,null,false).subscribe((accounts) => (this.accounts = accounts));
  }
  private getjournalId(id: number) {
    this.finaceService.getJournal(id).subscribe({
      next: (journal: Journal) => {
        this.journal = journal;
        this.setJournalForm(journal)
      },
    });
  }
  // JOURNAL
  public setJournalForm(journal?: Journal) {
    if (!journal)
      journal = {
        id: null,
        particular: null,
        date: null,
        disabled: false,
        payable: false,
        companyId: this.context?.companyId,
      } as Journal;
    this.journalForm = this.fb.group({
      id: this.fb.control(journal.id || null),
      particular: this.fb.control(journal.particular, [Validators.required]),
      date: this.fb.control(journal.date, [Validators.required]),
      companyId: this.fb.control(journal.companyId, [Validators.required]),
      disabled: this.fb.control(journal.disabled, []),
      payable: this.fb.control(journal.payable || false, []),
    });
    this.journalForm.valueChanges.subscribe(value => this.modified = true);
  }

  get f() {
    return this.journalForm.controls;
  }

  get t() {
    return this.transationForm.controls;
  }

  public saveJournal(inProgresss?: any) {
    this.submitted = true;
    if (this.journalForm.valid) {
      const journal: Journal = this.journalForm.value;
      if (this.journals.some(t => t.particular.toLowerCase() === journal.particular.toLowerCase())) {
        this.commonService.setToastr(400, `Cannot ${journal?.id?'update':'add'} the record. ${journal.particular} already exists.`);
        return;
      }
      if (!this.modified) {
        this.commonService.setToastr(200, `Journal has been updated successfully!`);
        return;
      }
      inProgresss.value = true;
      if (journal.id) {
        this.finaceService.updateJournal(journal.id, journal).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              inProgresss.value = false;
              this.commonService.setToastr(200, `Journal has been updated successfully!`);
            } else {
              inProgresss.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
            this.submitted = false;
          },
          error: (error: HttpErrorResponse) => {
            inProgresss.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.finaceService.createJournal(journal).subscribe({
          next: (response: Journal) => {
            if (response) {
              this.journalId = response.id;
              this.journalForm.get("id").setValue(this.journalId);
              this.passEntry.emit(response);
              this.commonService.setToastr(200, `Journal has been created successfully!`);
              inProgresss.value = false;
            } else {
              inProgresss.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgresss.value = false;
          },
        });
      }
    }
  }

  //  JOURNAL TRANSACTION
  get byTransations(): FormArray {
    return this.transationForm.get("byTransations") as FormArray;
  }

  get toTransations(): FormArray {
    return this.transationForm.get("toTransations") as FormArray;
  }

  public pushByTransation(transation: Transaction) {
    this.addByTransation();
  }

  public pushToTransation(transation: Transaction) {
    this.addToTransation();
  }

  private setTransations(transactions: Transaction[]) {
    this.transationForm = this.fb.group({
      byTransations: this.fb.array([]),
      toTransations: this.fb.array([]),
    });
    if (!this.journal?.id) {
      this.addByTransation();
      this.addToTransation();
    }
  }

  private addByTransation(byTransation?: Transaction) {
    this.byTransations.push(this.fb.group({
      id: this.fb.control(byTransation?.id || null, []),
      refId: this.fb.control(byTransation?.refId, []),
      type: this.fb.control(byTransation?.type || 'JOURNAL', []),
      byAccount: this.fb.control(byTransation?.byAccount || true, []),
      amount: this.fb.control(byTransation?.amount, [Validators.required]),
      accountId: this.fb.control(byTransation?.accountId, [Validators.required]),
    }));
  }

  private addToTransation(toTransation?: Transaction) {
    this.toTransations.push(this.fb.group({
      id: this.fb.control(toTransation?.id || null, []),
      refId: this.fb.control(toTransation?.refId, []),
      type: this.fb.control(toTransation?.type || 'JOURNAL', []),
      byAccount: this.fb.control(toTransation?.byAccount || false, []),
      amount: this.fb.control(toTransation?.amount, [Validators.required]),
      accountId: this.fb.control(toTransation?.accountId, [Validators.required]),
    }));
  }

  public saveTransation() {
    const totalByAmount = this.byTransations.value.reduce((sum, item) => sum + (item.amount || 0), 0);
    const totalToAmount = this.toTransations.value.reduce((sum, item) => sum + (item.amount || 0), 0);
    if (totalByAmount !== totalToAmount) {
      this.toaster.warning('"By total" and "To total" should be equal. Please check both amounts.');
      return;
    }
    if (this.isPaymentEnabled || this.payId) {
      this.populatePaymentData();
    }
    let byTransation = this.byTransations.value;
    let toTransation = this.toTransations.value;
    let byPayments = this.byPayments.value;
    let toPayments = this.toPayments.value;
    let filteredToPayments = toPayments.filter(payment => payment.accountId !== null && payment.amount !== null);
    let transantions: Transaction[] = byTransation.concat(toTransation, byPayments, filteredToPayments);
    transantions.forEach(t => {
      if (t.type === 'JOURNAL') {
        t.refId = this.f.id.value;
      } else {
        t.refId = this.w.id.value;
      }
    });
    transantions = transantions.filter(t => t.refId);
    let updateTransations = transantions.filter(transaction => transaction.id !== null);
    let createTransactions = transantions.filter(transaction => transaction.id == null);
    if (this.transationForm.valid) {
      const isUpdateProcess = updateTransations.length > 0;
      if (updateTransations.length > 0) {
        this.updateTransation(transantions);
      } else {
        this.createTransation(transantions, isUpdateProcess);
      }
    } else {
      this.commonService.setToastr(500, 'Please enter valid journal entry details.');
    }
  }

  private createTransation(transactions: Transaction[], isUpdateProcess: boolean = false) {
    this.finaceService.createTransation(transactions).subscribe({
      next: (message: Message) => {
        if (!isUpdateProcess && !message.failed) {
          this.getTransactions(this.journalId)
          this.commonService.setToastr(200, message.text);
        } else if (message.failed) {
          this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toaster.error(error?.error?.name || error.message);
      }
    });
  }

  private updateTransation(transactions: Transaction[]) {
    this.finaceService.updateTransation(transactions).subscribe({
      next: (message: Message) => {
        if (!message.failed) {
          this.getTransactions(this.journalId);
          this.commonService.setToastr(200, message.text);
        } else {
          this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toaster.error(error?.error?.name || error.message);
      }
    });
  }

  public deleteByTransation(index: number): void {
    if (this.byTransations.length > 1) {
      this.byTransations.removeAt(index);
    }
  }


  public deleteToTransation(index: number): void {
    if (this.toTransations.length > 1) {
      this.toTransations.removeAt(index);
    }
  }

  public onPayButtonClick(): void {
    this.journalForm.get('payable')?.setValue(true);
    if (this.journalId) {
      this.finaceService.updateJournal(this.journalId, this.journalForm.value).subscribe({
        next: (response: Message) => {
          if (!response.failed) {
            this.commonService.setToastr(200, 'Payment process unlocked! Additional actions are now available below.');
          } else {
            this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
          }
        },
        error: (error: HttpErrorResponse) => {
          this.commonService.setToastr(500, error?.error?.name || error.error);
        },
      });
    }
  }

  //  PAYMENT
  public setPaymentForm(payment?: Payment) {
    if (!payment)
      payment = {
        id: null,
        journalId: null,
        date: null,
        particular: null,
      } as Payment;
    this.payForm = this.fb.group({
      id: this.fb.control(payment.id || this.payId || null),
      particular: this.fb.control(payment.particular, []),
      date: this.fb.control(payment.date, [Validators.required]),
      journalId: this.fb.control(payment.journalId || this.f.id.value, []),
    });
    this.payForm.valueChanges.subscribe(value => this.modified = true);
  }

  get p() {
    return this.paymentForm.controls;
  }

  get w() {
    return this.payForm.controls;
  }

  public savePayment(inProgress?: any) {
    this.submittedPayment = true;
    if (this.payForm.valid) {
      this.populatePaymentData();
      const payment: Payment = this.payForm.value;
      payment.journalId = this.f.id.value;
      if (!this.modified) {
        this.commonService.setToastr(200, `Payment has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (payment.id) {
        this.finaceService.updatePayment(payment.id, payment).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              // this.populatePaymentData();
              inProgress.value = false;
              this.commonService.setToastr(200, response.text);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
            this.submitted = false;
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.finaceService.createPayment(payment).subscribe({
          next: (response: Message) => {
            if (response) {
              this.populatePaymentData();
              this.paymentId = parseInt(response.payload);
              this.payForm.get("id").setValue(this.paymentId);
              this.passEntry.emit(response);
              this.commonService.setToastr(200, response.text);
              inProgress.value = false;
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
          },
        });
      }
    }
  }

  //  PAYMENT TRANSACTION
  get byPayments(): FormArray {
    return this.paymentForm.get("byPayments") as FormArray;
  }

  get toPayments(): FormArray {
    return this.paymentForm.get("toPayments") as FormArray;
  }

  public pushToPayment(payment: Payment) {
    this.addToPayment();
  }

  private setPayments(toPayments: Transaction[]) {
    this.paymentForm = this.fb.group({
      byPayments: this.fb.array([]),
      toPayments: this.fb.array([]),
    });
    if (!this.journal?.id) {
      this.addToPayment();
    }
  }

  private addToPayment(toPayment?: Transaction) {
    this.toPayments.push(this.fb.group({
      id: this.fb.control(toPayment?.id || null, []),
      refId: this.fb.control(toPayment?.refId || this.paymentId, []),
      type: this.fb.control(toPayment?.type || 'PAYMENT', []),
      byAccount: this.fb.control(toPayment?.byAccount || false, []),
      amount: this.fb.control(toPayment?.amount, [Validators.required]),
      accountId: this.fb.control(toPayment?.accountId, [Validators.required]),
    }));
  }

  private addByPayment(byPayment?: Transaction) {
    this.byPayments.push(this.fb.group({
      id: this.fb.control(byPayment?.id || null, []),
      refId: this.fb.control(byPayment?.refId || this.paymentId, []),
      type: this.fb.control(byPayment?.type || 'PAYMENT', []),
      byAccount: this.fb.control(byPayment?.byAccount || true, []),
      amount: this.fb.control(byPayment?.amount, [Validators.required]),
      accountId: this.fb.control(byPayment?.accountId, [Validators.required]),
    }));
  }

  public upsertPayment() {
    const totalByAmount = this.byPayments.value.reduce((sum, item) => sum + (item.amount || 0), 0);
    const totalToAmount = this.toPayments.value.reduce((sum, item) => sum + (item.amount || 0), 0);
    if (totalToAmount > totalByAmount) {
      this.toaster.warning('The "To total" should not be greater than the "By total".');
      return;
    }
    let byPayments = this.byPayments.value;
    let toPayments = this.toPayments.value;
    let payments: Transaction[] = byPayments.concat(toPayments);
    payments.forEach(t => {
      if (t.type === 'JOURNAL') {
        t.refId = this.f.id.value;
      } else {
        t.refId = this.w.id.value;
      }
    });
    payments = payments.filter(p => p.refId);
    let updatePayments = payments.filter(transaction => transaction.id !== null);
    let createPayments = payments.filter(transaction => transaction.id == null);
    if (this.paymentForm.valid) {
      const isUpdateProcess = updatePayments.length > 0;
      if (updatePayments.length > 0) {
        this.updatePayment(payments);
      } else {
        this.createPayment(payments, isUpdateProcess);
      }
    }
    else {
      this.commonService.setToastr(500, 'Please enter valid payment entry details.');
    }
  }

  private createPayment(payments: Transaction[], isUpdateProcess: boolean = false) {
    this.finaceService.createTransation(payments).subscribe({
      next: (message: Message) => {
        if (!isUpdateProcess && !message.failed) {
          this.getTransactions(this.journalId)
          this.commonService.setToastr(200, message.text);
        } else if (message.failed) {
          this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toaster.error(error?.error?.name || error.message);
      }
    });
  }

  private updatePayment(payments: Transaction[]) {
    this.finaceService.updateTransation(payments).subscribe({
      next: (message: Message) => {
        if (!message.failed) {
          this.getTransactions(this.journalId);
          this.commonService.setToastr(200, message.text);
        } else {
          this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toaster.error(error?.error?.name || error.message);
      }
    });
  }

  public deleteToPayment(index: number): void {
    if (this.toPayments.length > 1) {
      this.toPayments.removeAt(index);
    }
  }

  public disableByAccount(id: number): boolean {
    return this.byTransations.value.some(e => e.accountId === id);
  }

  public disableToAccount(id: number): boolean {
    return this.toTransations.value.some(e => e.accountId === id);
  }

  public disableAccountPayment(id: number): boolean {
    return this.toPayments.value.some(e => e.accountId === id);
  }

  get totalByAmount(): number {
    return this.calculateTotal(this.byTransations);
  }

  get totalToAmount(): number {
    return this.calculateTotal(this.toTransations);
  }

  get totalByAmountPayment(): number {
    return this.calculateTotal(this.byPayments);
  }

  get totalToAmountPayment(): number {
    return this.calculateTotal(this.toPayments);
  }

  private calculateTotal(transactions: FormArray): number {
    return transactions.controls.reduce((sum, control) => {
      const amount = control.get('amount')?.value;
      return sum + (amount ? parseFloat(amount) : 0);
    }, 0);
  }

  private getTransactions(id: number) {
    this.finaceService.getTransations(id).subscribe({
      next: (transactions: Transaction[]) => {
        transactions = transactions.map(transaction => ({ ...transaction, type: transaction.type.toUpperCase(), }));
        let byTransasctions: Transaction[] = transactions.filter(transaction => transaction.type === 'JOURNAL').filter(journal => journal.byAccount);
        let toTransasctions: Transaction[] = transactions.filter(transaction => transaction.type === 'JOURNAL').filter(journal => !journal.byAccount);
        let byPayments: Transaction[] = transactions.filter(transaction => transaction.type === 'PAYMENT').filter(payment => payment.byAccount);
        let toPayments: Transaction[] = transactions.filter(transaction => transaction.type === 'PAYMENT').filter(payment => !payment.byAccount);
        this.byTransations.clear();
        if (byTransasctions.length > 0) {
          byTransasctions.forEach(transaction => this.addByTransation(transaction));
        } else {
          this.addByTransation();
        }
        this.toTransations.clear();
        if (toTransasctions.length > 0) {
          toTransasctions.forEach(transaction => this.addToTransation(transaction));
        } else {
          this.addToTransation();
        }
        this.byPayments.clear();
        if (byPayments.length > 0) {
          byPayments.forEach(transaction => this.addByPayment(transaction));
        } else {
          this.populatePaymentData();
        }
        this.toPayments.clear();
        if (toPayments.length > 0) {
          toPayments.forEach(transaction => this.addToPayment(transaction));
        } else {
          this.addToPayment();
        }
        this.isPaymentEnabled = transactions.some(transaction => transaction.id !== null && transaction.id !== undefined);
        this.hasPaymentIds = transactions.filter(transaction => transaction.refId).map(transaction => transaction.refId);
        this.hasToPaymentId = toPayments.some(item => item.id !== null);
        this.hasTransationId = toTransasctions.some(item => item.id !== null);
      },
      error: (err) => {
      },
    });
  }

  private getPayments(id: number) {
    this.finaceService.getPayments(id).subscribe({
      next: (payments: Payment[]) => {
        this.payments = payments;
        if (payments.length > 0) {
          const firstPayment = payments[0];
          this.payId = firstPayment.id;
          this.payForm.get('id')?.setValue(this.payId);
        }
        this.hasPaymentId = payments.some(payment => payment.id);
        this.populateDate(payments);
      },
      error: (error: HttpErrorResponse) => {
      },
    });
  }

  private populatePaymentData() {
    const toTransation = this.toTransations.value;
    const byPayment = toTransation
      .filter(transaction => transaction.type === 'JOURNAL' && !transaction.byAccount)
      .map(transaction => ({
        id: transaction.id || null,
        accountId: transaction.accountId || null,
        amount: transaction.amount || 0,
        refId: this.paymentId || null,
        byAccount: true,
        type: 'PAYMENT',
      }));
    const byPayments = JSON.parse(JSON.stringify(this.byPayments.value));
    this.byPayments.clear();
    byPayment.forEach(transaction => {
      if (byPayments?.length < 1) {
        this.byPayments.push(
          this.fb.group({
            id: [null],
            accountId: [transaction.accountId,],
            amount: [transaction.amount,],
            refId: [transaction.refId,],
            byAccount: [transaction.byAccount,],
            type: [transaction.type,],
          })
        );
      }
      byPayments?.forEach((p, i) => {
        if (p?.id && p.accountId === transaction.accountId) {
          this.byPayments.push(
            this.fb.group({
              id: [p.id],
              accountId: [p.accountId,],
              amount: [transaction.amount,],
              refId: [p.refId,],
              byAccount: [p.byAccount,],
              type: [p.type,],
            }))
        }
      })
      if (transaction.id === null) {
        this.byPayments.push(
          this.fb.group({
            id: [null],
            accountId: [transaction.accountId,],
            amount: [transaction.amount,],
            refId: [transaction.refId,],
            byAccount: [transaction.byAccount,],
            type: [transaction.type,],
          })
        );
      }
    });
  }

  private populateDate(payments: any[]): void {
    if (payments && payments.length > 0) {
      const paymentDate = payments[0].date.split('T')[0];
      this.payForm.patchValue({
        date: paymentDate,
      });
    }
  }

  public hasTransactionIds(): boolean {
    return
  }
}
